import { IRequestFormConfig } from '../interfaces/request/request-form-config.interface';
import { FILE_FORMAT } from '../enums/file/file-format.enum';

export const GARMENT_3D_CONFIG: IRequestFormConfig = {
  canOnlyBeDrafted: true,
  files: [
    {
      type: 'SIZE_TABLE',
      fileFormats: [FILE_FORMAT.CSV, FILE_FORMAT.XLS, FILE_FORMAT.JSON],
      multiplicity: [0, 1],
    },
    {
      type: 'REFERENCE_ADDITIONAL',
      fileFormats: [FILE_FORMAT.JPEG, FILE_FORMAT.PNG],
      multiplicity: [0, Number.MAX_SAFE_INTEGER],
    },
  ],
};
